/**
 * MemberCenter主控制器
 */

define('controllers/MemberCenterController',['app', "mainCons", 'loginValidation'], function (app, mainCons, loginValidation) {
    app.controller('MemberCenterController', ['$scope', '$q', '$rootScope', '$state', '$timeout', '$location', 'biAnalyticService', 'UserInfo', 'OpenTrade', 'OpenOther', 'auiDialog', 'ngDialog', 'OpenUp', 'modUserInfoService',
        '$filter', 'HuaweiTrade', '$window', 'modBussService', 'invoiceService', '$transitions', 'auiAgreementHelper', 'userAuth', '$anchorScroll', 'tenantsService', 'serviceresource', 'payService', 'remindToUpdateUserInfo', 'auiChangeTeamAccountService', 'dialogQuestionnaireTip', 'auiAppTransferService', 'petalsService',
        function ($scope, $q, $rootScope, $state, $timeout, $location, biAnalyticService, UserInfo, OpenTrade, OpenOther, auiDialog, ngDialog, OpenUp, modUserInfoService, $filter,
                  HuaweiTrade, $window, modBussService, invoiceService, $transitions, auiAgreementHelper, userAuth, $anchorScroll, tenantsService, serviceresource, payService, remindToUpdateUserInfo, auiChangeTeamAccountService, dialogQuestionnaireTip, auiAppTransferService, petalsService) {
            if (document && document.referrer && ((document.referrer.indexOf('/consumer/cn/partner') != -1 && document.referrer.indexOf('/consumer/cn/partners') == -1) || document.referrer.indexOf('/consumer/cn/resellermanager') != -1)) {
                AUI.BaseJSUtil.redirectUrl(systemParaConf.user.resellerConsole);
                return;
            }
            /* 2. $scope变量声明 */

            if (AUI.BaseJSUtil.isMobileTerminal()) {
                if (!alert("建议您通过PC访问管理中心")) {
                    AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.indexUrl);
                }
                return;
            }
            var index = location.protocol + "//" + location.host;
            var Model = $scope.Model = {
                unPayedOrder: 0,
                unReadMsgNum: 0,
                count: 0,
                userTypePer: 1,
                userInfo: UserInfo.get(),
                problemNum: 0,
                userTypeCorp: 2,
                unReadQuestions: 0,
                iframhelpUrl: sysParamCfg.esdkHelpTip.iframhelpUrl,
                isMenuHasApi: false
            };
            Model.mainUserID = AUI.HDGWCall.getUserInfoValue('teamid');
            $scope.mainUserID = AUI.HDGWCall.getUserInfoValue('teamid');
            Model.isChangeAccount = true;
            $scope.forumDiversionConf = sysParamCfg.forumDiversionConf;
            $scope.dropList = sysParamCfg.dropList;
            $scope.flag = false;
            $scope.refreshMsgNumber = refreshMsgNumber;
            window.refreshMsgNumber = refreshMsgNumber;
            window.openPage = function (pathname) {
                if (!AUI.BaseJSUtil.checkUrl(pathname)) {
                    AUI.BaseJSUtil.redirectUrl(index + pathname)
                } else {
                    AUI.BaseJSUtil.redirectUrl(pathname);
                }

            };
            window.gotoAppService = function () {
                $state.go("home");
            };
            window.gotoNewState = function (url, param) {
                $state.go(url, param, {reload: true});
            };
            //切换横幅提示  给angular11做的特殊处理
            window.gotoStateChangedEvent = function () {
                UserInfo.updateCache(function (res) {
                    $rootScope.$emit("stateChangedEvent", true);
                })
            };
            $scope.refreshUnreadQuestions = refreshUnreadQuestions;
            $scope.homePage = sysUrlCfg.user.indexUrl;
            $scope.today = new Date().getTime();
            $scope.after2Month = new Date().getTime() + sysParamCfg.today2MonthTime;
            $scope.logOut = logOut;
            $scope.gotoUserCenter = gotoUserCenter;
            $scope.showClick = showClick;
            $scope.showHelp = showHelp;
            $scope.headDefaultImg = sysParamCfg.user.headDefaultImg;
            $scope.agreetIndex = 1;
            $scope.esdkIsNeedShow = true;
            $scope.esdkShowWhat = sysParamCfg.esdkHelpTip.showWhat;
            $scope.showEsdkHelpIframe = false;
            $scope.contractUsDev = window.sysUrlCfg.documentHref.contractUs;
            //自定义桌面
            $scope.isCustomizerShown = false; // 定制器显示开关
            $scope.showCustomizer = showCustomizer; // 打开定制器
            $scope.customizeCard = customizeCard; // 定制/取消卡片
            $scope.hasUncustomizedNewServiceCards = serviceresource.customizer.hasUncustomizedNewServiceCards; // 显示/隐藏new图标
            $scope.selectState = 1;
            $scope.isCustomizerGuideShown = false; // 定制器向导的显示开关
            $scope.getServiceCardMenu = getServiceCardMenu; // 获取服务卡片菜单
            $scope.getReportCardMenu = getReportCardMenu; // 获取报表卡片菜单
            $scope.getAccountCardMenu = getAccountCardMenu; // 获取我的账户片菜单
            $scope.getMySettingMenu = getMySettingMenu; // 获取设置菜单
            $scope.getLeftMenu = getLeftMenu; // 获取左侧菜单
            $rootScope.getNavigationMenu = getNavigationMenu; //获取导航菜单
            $scope.getAllServiceCards = getAllServiceCards; // 获取全部服务卡片，树形结构
            $scope.hasCustomizedServiceCards = hasCustomizedServiceCards; // 目录下是否存在定制过的服务卡片，用于菜单隐藏处理
            $scope.hasCustomizedReportCards = hasCustomizedReportCards; // 目录下是否存在定制过的报表卡片，用于菜单隐藏处理
            $scope.cancelDeveloperUpdate = userAuth.cancelDeveloperUpdate; // 撤销实名认证
            $scope.hasorderListPermission = false;
            $scope.hasTeamMemberPermission = false;
            $scope.activityPage_url = sysParamCfg.appPromotion.activityPage_url;
            $scope.hasMemberServicesPermission = false;
            $scope.hasIncomePermission = false;
            $scope.hasBillPermission = false;
            $scope.openSec = openSec;
            //展示提示语列表
            var swiper = null;
            var isSelectTab = false; // tab 页签是否被点击
            var isFirstTimeGuide = true; // 是否首次显示向导
            $scope.changeTeamAccount = changeTeamAccount; // 切换团队帐号
            $scope.isCoverShow = false;
            $rootScope.isGray = 1;
            $rootScope.isqrcodeshow = true;
            Model.userInfo.isShowAccountChange = false;
            //系统用户角色配置
            var roleTypeCfg = sysParamCfg.roleType;
            //问卷调查的弹窗的提醒时间配置
            var questionnaireDeadlineTime = sysParamCfg.questionnaireDeadlineTime;

            $scope.showEsdkHelpShow = function () {
                auiAgreementHelper.checkAgreement(sysParamCfg.esdkHelpAgreement, function () {
                }, Model.userInfo).then(function (data) {
                    var isSigned = data.signed; //是否已经签署最新协议
                    if (isSigned) {
                        $scope.showEsdkHelpIframe = true;
                        if ($scope.showEsdkHelpIframe) {
                            $("#esdkShow").attr("src", $scope.esdkShowWhat);
                        }
                    }
                });

            };

            $scope.closeEsdkHelpShow = function ($event) {
                var tag = $event.target;
                if (tag && tag.getAttribute("name") != "Help") {
                    $scope.showEsdkHelpIframe = false;
                }
            };

            function openSec(leftMenu, getLeftMenu) {
                if (leftMenu.resourceTree.length == 0) return;
                if (!leftMenu.isOpen) {
                    getLeftMenu.forEach(function (menu) {
                        menu.isOpen = false;
                    });
                }
                leftMenu.isOpen = ((leftMenu.isOpen) ? false : true);
            }

            // 菜单点亮处理
            $scope.isMenuActived = function (menu) {
                if (!menu.hashList) return false;

                var homeDir = serviceresource.cards.getHomeDir() || {},
                    currentHash = window.location.hash,
                    menuHash = typeof menu.hashList === 'string' ? JSON.parse(menu.hashList) : menu.hashList;

                // dirId 为空时点亮首个有卡片的菜单
                if (currentHash === '#/serviceCards/' && menu.itemCode === homeDir.itemCode) return true;

                // hash 比对点亮
                if (menuHash.some(function (hash) {
                    if (/\*$/.test(hash)) {
                        if (!currentHash.indexOf(hash.slice(0, -1)))
                            return true;
                    } else {
                        if (currentHash === hash) return true;
                    }
                    return false;
                })) return true;
                return false;
            };
            //进商户服务页面
            $scope.goMerchant = function () {
                $scope.focusItem = "taxQualification";
                $state.go('mysetting.modBussnessInfo', {}, {reload: true});
            };

            var templateInfoList = null;
            //多个协议重签
            $scope.signAgreement = function (templateInfo) {
                var sizeOra = $scope.agreeList.length;
                var agreeL = angular.copy($scope.agreeList);
                var agreeI = angular.copy($scope.agreetIndex);
                auiAgreementHelper.agreeMentDialogPDFMulti(agreeL, true, agreeI).then(function (size) {
                    if (size != sizeOra) {
                        // 判断是否有协议签署，如果已经签署了部分协议， 就刷新页面
                        $window.location.reload();
                    }
                });
            };
            $scope.clickPage = function () {
                var nodeLi = $("ul.paging-point li");
                $.each(nodeLi, function (i, item) {
                    var clsName = item.className;
                    var index = clsName.indexOf("active");
                    if (-1 != index) {
                        var resultIndex = i + 1;
                        if (resultIndex > 0 && resultIndex <= $scope.agreeList.length) {
                            $scope.agreetIndex = resultIndex;
                        }
                        return;
                    }
                });
            };

            $scope.clickPageNew = function () {
                var nodeLi = $("ul.paging-point li");
                $.each(nodeLi, function (i, item) {
                    var clsName = item.className;
                    var index = clsName.indexOf("active");
                    if (index != -1) {
                        var resultIndex = i + 1;
                        if (resultIndex > 0 && resultIndex <= $scope.msgList.length) {
                            $scope.agreetIndex = resultIndex;
                        }
                        return;
                    }
                });
            };

            /* 菜单样式统一处理   end */
            $transitions.onStart({}, function (trans) {
                var $state = trans.router.stateService;
                authenticate($state, trans);
                getQueryForEarningSettlement(trans);
            });

            $transitions.onSuccess({}, function (trans) {
                angular.element('html, body').animate({         //添加animate动画效果
                    scrollTop: 0
                }, 16);
                var $state = trans.router.stateService;
                authenticateSuccess($state, trans);
            });
            // 选择 tab 页签
            $scope.selectTab = function (hashName, selectValue) {
                $scope.selectState = selectValue;
                isSelectTab = true;
                $anchorScroll(hashName);
            }

            // 关闭自定义卡片界面
            $scope.closeCustomizer = function () {
                var currentDirId = $state.params.dirId;
                // 至少选择一项服务
                if (!serviceresource.customizer.hasCustomizedServiceCards()) {
                    auiDialog.warn("请至少选择一项服务。");
                    return;
                }

                $scope.isCustomizerGuideShown = false;
                $scope.isCustomizerShown = false;

                // 如果当前所在目录下无定制卡片则跳转到首页
                if (currentDirId && !serviceresource.customizer.hasCustomizedServiceCards(currentDirId)) {
                    $state.go('home');
                }

                // 不再显示自定义卡片向导
                if (isFirstTimeGuide) {
                    noShowCustomizerGuide();
                    // 显示帮助步骤图
                    showHelp(true);
                }
            }

            /* 菜单样式统一处理 start */
            /**
             * @example
             * <!-- 单个状态 -->
             * <a ui-sref="example" ng-class="{'active': $state.contains('example')}">menu</a>
             * <!-- 多个状态 -->
             * <a ui-sref="example" ng-class="{'active': $state.contains(['example1', 'example2'])}">
             */
            $scope.$state = $state;
            $scope.$state.contains = function (state) {
                if (typeof state == 'string') {
                    return $state.current.name.indexOf(state) > -1 &&
                        $state.current.name.replace(new RegExp(state), '').indexOf('.') <= 0;
                } else if (typeof state == 'object' && state.length) {
                    return state.some(function (v) {
                        return $state.current.name.indexOf(v) > -1 && $state.current.name.replace(new RegExp(v), '').indexOf('.') <= 0;
                    });
                } else {
                    throw 'State type error ';
                }
            };

            //监听提交事件
            $rootScope.$on('stateChangedEvent', function (event, data) {
                $scope.msgList = [];
                if (templateInfoList === null) {
                    //说明是在商户页面刷新的 需要对其重新赋值
                    auiAgreementHelper.processAgreements().then(function (result) {
                        //前台无法保证签协议添加角色原子性，只能采用查询如果缺少则添加的方式,代理和开发者互斥
                        //放到这里表示开发者协议已经更新过了
                        templateInfoList = result;
                        if (templateInfoList && templateInfoList !== true && templateInfoList.length > 0) {
                            $scope.agreeList = templateInfoList; //非强签协议list
                        }
                        $scope.setTipMsg($state.$current.name).then(function (result) {
                            $scope.msgList = $scope.filterClosedMsg(result);
                            swiper = null;
                            displayAgreeListNew($scope.msgList);
                        });
                    });
                } else {
                    $scope.setTipMsg($state.$current.name).then(function (result) {
                        $scope.msgList = $scope.filterClosedMsg(result);
                        swiper = null;
                        displayAgreeListNew($scope.msgList);
                    });
                }
            });

            /**
             * 页面初始化逻辑，在这里实现
             */
            !function init() {
                // 设置validauth true表示要走鉴权逻辑
                window.sessionStorage.setItem("validAuth", true);
                UserInfo.getNickName().then(function (nikeInfo) {
                    UserInfo.getUserAllRouteInfo().then(function (allUserRouteInfo) {
                        UserInfo.getUserRouteInfo(true, allUserRouteInfo).then(function (data) {
                            // 调用OpenOther的syncManagedIDUserInfo接口同步华为帐号的团队帐号数据，异步
                            if (sysParamCfg.switchConf.isShowEAMType) {
                                UserInfo.syncManagedIDUserInfo();
                            }
                            // 调用developer接口获取华为云的认证状态，异步调用，无任何阻塞
                            UserInfo.getHwcloudVerifyState();
                            pageMonitoring();
                            UserInfo.promise().then(function (user) {
                                if (data.currentUserRouteInfo.memberUserID) {
                                    $scope.memberUserID = data.currentUserRouteInfo.memberUserID;
                                }
                                //判断是否是法务
                                $scope.isLegal = data.isLegal;
                                $scope.isAdmin = data.isAdmin;
                                //如果是开发者角色并且没有代理的情况下优先加载菜单接口，为了菜单加载快
                                if (AUI.BaseJSUtil.contains(data.roleList, roleTypeCfg.SM) && !AUI.BaseJSUtil.contains(data.roleList, roleTypeCfg.PopProxy)) {
                                    serviceresource.init(data).then(function () {
                                        afterChangeTeamAccount(data);
                                    });
                                } else {
                                    afterChangeTeamAccount(data);
                                }
                            })
                        })
                    }).catch(function (e) {//针对管理式帐号的处理
                        var div = document.getElementById('modal');
                        div.style.display = "none";
                    })
                });


            }();

            //APM JS SDK  提供WEB 页面性能监控
            function pageMonitoring() {
                window.APM && APM.setServiceId('OpenAlliance-PartnerDPRMService-PartnerDPRMPortal'); // 设置业务标识
                window.APM && APM.setReportQuantity(100); // 设置每次上报的数量上限
                window.APM && APM.setReportUrl(sysUrlCfg.setSDKReportUrl); // 设置上报地址
                window.APM && APM.createTrace('traceDPRMPortal'); //设置记录名称
                window.APM && APM.enable(true); // 启用开关。true:启用 false:关闭
            }

            //添加开发者角色
            function addSMRole() {
                var defer = $q.defer();
                userAuth.addRole(roleTypeCfg.SM).then(function () {
                    $window.location.reload();
                    defer.reject();
                }, function () {
                    defer.resolve();
                });
                return defer.promise;
            }

            //签署单个协议拒绝签署的回调
            var callback = function () {
                AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.indexUrl);
            };

            //检查并签署隐私和开发者服务协议
            function checkSignDevAgree(roles, userInfo) {
                var defer = $q.defer();
                //开发者服务协议
                var devAgree = {agrType: 1000, country: 'cn', count: 1};
                var params = [];
                var isSMRoleType = false;
                if (userInfo.userRouteInfo && userInfo.userRouteInfo.currentUserRouteInfo && userInfo.userRouteInfo.currentUserRouteInfo.channelRoleTypes && userInfo.userRouteInfo.currentUserRouteInfo.channelRoleTypes.length > 0) {
                    userInfo.userRouteInfo.currentUserRouteInfo.channelRoleTypes.forEach(function (channelRoleType) {
                        if (channelRoleType.roleClassify == 1) {
                            isSMRoleType = true;
                        }
                    });
                }
                //是否要检查并签署协议
                //获取角色配置信息-是否需要签署开发者协议 needCheck true/false
                userAuth.shouldCheckDevAgree(roles).then(function (needCheck) {
                    //配置的需要签署协议，或者用户包含广告主(审核中或通过）且不是开发者且已实名通过
                    needCheck = !AUI.BaseJSUtil.contains(roles, roleTypeCfg.PopProxy) && (needCheck || (AUI.BaseJSUtil.contains([1, 2], userInfo.verifyRealState) && roles && AUI.BaseJSUtil.contains(roles, roleTypeCfg.Ad)));
                    if (needCheck) {
                        params = [devAgree];
                    }
                    //检查隐私和开发者协议 没有签署就让他签
                    auiAgreementHelper.checkAgreements(params, callback, Model.userInfo).then(function (rs) {
                        if (rs && rs.signed == false) {
                            callback();
                        } else {
                            //这个返回，用于在协议更新之后添加角色
                            defer.resolve({roles: roles, agree: rs, needCheck: needCheck, isSMRoleType: isSMRoleType});
                        }
                    });
                });
                return defer.promise;
            }

            function afterChangeTeamAccount(data) {
                UserInfo.promise().then(function (latestUserInfo) {
                    loginValidation.validateAfterLogin(latestUserInfo, function () {
                        var div = document.getElementById('modal');
                        div.style.display = "none";
                        Model.userInfo = latestUserInfo;
                        Model.userInfo.userRouteInfo = data;
                        Model.userRouteInfo = data;
                        if (latestUserInfo.verifyRealState == 2) {
                            refreshMsgNumber();
                        }
                        //先检查并签署协议，再根据角色配置用户状态控制跳转
                        checkSignDevAgree(data.roleList, Model.userInfo).then(function (rs) {
                            //检查单签协议
                            checkSpecificAgreement().then(function (signStatus) {
                                //标识这个人已经弹窗过了 不管是怎么样的
                                if (signStatus) {
                                    sessionStorage.setItem(Model.userInfo.id + 'SpecificAgreement', signStatus);
                                }
                                //检查协议更新
                                processAgreementsMain(Model.userInfo, rs);
                            })

                            //读取浏览器信息，展示浏览器提醒
                            var browser = AUI.BaseJSUtil.getBrower();
                            if (browser.ie && browser.ie.split('.')[0] < 10) {
                                $scope.showBrower = true;
                            } else if (browser.firefox && browser.firefox.split('.')[0] < 50 && browser.firefox.split('.')[0] != 39) {
                                $scope.showBrower = true;
                            } else if (browser.chrome && browser.chrome.split('.')[0] < 56) {
                                $scope.showBrower = true;
                            }
                            $timeout(function () {
                                _initAsideNav();
                                windowResize();
                            }, 0);
                        }, function () {

                        });
                    }, true, Model.mainUserID, null, true); // true 不需要再校验非简化实名认证了 Model.mainUserID表示如果是成员帐号不要再校验了。
                });
            }

            //检查单签协议并且判断是否签署
            function checkSpecificAgreement() {
                var defer = $q.defer();
                //已经弹窗过了也不弹了
                if ((!Model.mainUserID || $scope.isLegal) && !sessionStorage.getItem(Model.userInfo.id + 'SpecificAgreement')) {
                    OpenUp.getTobeSignedSpecificAgreement({req: {portalType: 1}}).then(function (resp) {
                        if (resp && resp.tobeSignedSpecificAgreement && resp.tobeSignedSpecificAgreement.length > 0) {
                            auiAgreementHelper.specificAgreementDialogPDFMulti(resp.tobeSignedSpecificAgreement).then(function (flag) {
                                defer.resolve(flag);
                            });
                        } else {
                            defer.resolve();
                        }
                    });
                } else {
                    defer.resolve();
                }
                return defer.promise;
            }

            // 初始化卡片服务
            function initServiceCard(latestUserInfo) {
                serviceresource.init(latestUserInfo).then(function () {
                    if (latestUserInfo.verifyRealState == 2) {
                        if (latestUserInfo.userType == 2) {
                            refreshOrder();
                        }
                        refreshMemberService();
                    }
                    var leftMenuList = getLeftMenu();
                    if (leftMenuList && leftMenuList.length > 0) {
                        leftMenuList.forEach(function (leftMenu) {
                            if (leftMenu.itemCode == 'myApi' || leftMenu.itemCode == 'apiList' || leftMenu.itemCode == 'credentials' || leftMenu.itemCode == 'dashboard') {
                                Model.isMenuHasApi = true;
                            }
                        });
                    }
                    $scope.hasTeamMemberPermission = hasAuthority("TeamService", leftMenuList);
                });
            }

            //判断用户协议是否需要重签，如果需要重签弹框
            function processAgreementsMain(latestUserInfo, rs) {
                auiAgreementHelper.processAgreements(latestUserInfo).then(function (result) {
                    //前台无法保证签协议添加角色原子性，只能采用查询如果缺少则添加的方式,代理和开发者互斥
                    //放到这里表示开发者协议已经更新过了
                    templateInfoList = result;
                    if (rs && rs.needCheck && !rs.isSMRoleType && rs.agree && rs.agree.signed && !Model.mainUserID) {
                        addSMRole().then(function () {
                            userAuth.init(Model).then(function () {
                                // 初始化自定义卡片向导
                                openQuestionnaire(latestUserInfo);
                            });
                            initServiceCard(latestUserInfo);
                        });
                    } else {
                        userAuth.init(Model).then(function () {
                            // 初始化自定义卡片向导
                            if (!Model.mainUserID) {
                                openQuestionnaire(latestUserInfo);
                            } else {
                                latestUserInfo.isAdmin = $scope.isAdmin;
                                petalsService.handleDailogForPetals(latestUserInfo).then(function (data) {
                                    handTipMsg();
                                });
                            }
                        });
                        initServiceCard(latestUserInfo);
                    }
                });
            }

            // 查询用户信息，并根据UserInfo用户状态提醒用户更新个人信息方法
            function updateUserInfoWith180Fun(latestUserInfo) {
                // 查询用户信息，并根据UserInfo用户状态提醒用户更新个人信息
                remindToUpdateUserInfo.remindToUpdateUserInfo(latestUserInfo, function () {
                    latestUserInfo.isAdmin = $scope.isAdmin;
                    petalsService.handleDailogForPetals(latestUserInfo).then(function () {
                        initCustomizerGuide();
                        refreshUnreadQuestions();
                    });

                });
            }

            // 问卷调查弹框
            function openQuestionnaire(latestUserInfo) {
                // 实名通过、商户认证或付费认证通过的主帐号且是企业用户 、没有做过问卷
                if (latestUserInfo.verifyRealState == 2 && latestUserInfo.userType == 2 && (latestUserInfo.payCertifyStatus == 2 || latestUserInfo.commerceCertifyStatus == 2)) {
                    OpenUp.queryQuestionnaire().then(function (data) {
                        if (($state.$current.name != 'questionnaire') && (!data.answerForQuestionnaire || (data.answerForQuestionnaire.updateTime && new Date(data.answerForQuestionnaire.updateTime.replace(/-/g, '/')).getTime() < new Date(questionnaireDeadlineTime).getTime()))) {
                            dialogQuestionnaireTip.openQuestionnaireTipDialog({
                                toNotQuestionnaireDeal: function () {
                                    updateUserInfoWith180Fun(latestUserInfo);
                                },
                                toQuestionnaireDeal: function () {
                                    handTipMsg();
                                    $state.go('questionnaire', {isUpdate: 1}, {reload: true});//直接就是去编辑页面
                                }
                            });
                        } else {
                            updateUserInfoWith180Fun(latestUserInfo);
                        }
                    });
                } else {
                    updateUserInfoWith180Fun(latestUserInfo);
                }
            }


            function displayAgreeListNew(msglist) {
                var timerTemp = $timeout(function () {
                    var oUl = document.getElementsByClassName("sample-grid")[0];
                    if (!swiper && oUl) {
                        swiper = new UCD.Swiper('.userguideTOP', {
                            slideSelector: '.sample-grid',
                            isNeedPointer: true,
                            loop: true,
                            autoPlay: true,
                            interval: 3000,
                            onChanged: function (index) {
                                $scope.$apply($scope.clickPageNew());
                            }
                        });
                        if (msglist.length > 0) {
                            $('.userguideTOP').data('Sliding') || swiper;
                        }
                    }

                }, 0);
            }

            //如果是从确认结算单或者对账明细跳到收益结算单，则按照上次的查询条件进行查询 否则删掉之前存的查询条件
            function getQueryForEarningSettlement(trans) {
                if (((trans.$from().name == 'MyAccount.newEarnings.settlement' || trans.$from().name == 'mysetting.modBussnessInfo') &&
                    trans.$to().name == 'MyAccount.newEarnings.settlement')) {
                    $rootScope.isGet = true;
                } else {
                    $rootScope.isGet = false;

                }
            }


            function authenticate(state, trans) {
                var defer = $q.defer();
                var ucdDatepickers = $('.ucd-datepicker');
                if ($rootScope.modFlag && !AUI.BaseJSUtil.contains(mainCons.modUserinfoConstant.notSwitchUrl, trans.$to().name)) {
                    if ($("[id^='ngdialog']").length === 0) {
                        auiDialog.confirm($rootScope.isInNameChange ? "更名操作还未完成，确定离开吗？" : "页面信息还没有保存，确定离开吗？", function () {
                            $rootScope.modFlag = false;
                            if (ucdDatepickers.length > 0) {
                                ucdDatepickers.remove();
                            }
                            delete $rootScope.isInNameChange;
                            if ($rootScope.changeNameParams) {
                                delete $rootScope.changeNameParams;
                            }
                            var toStateParameters = trans.params('to');
                            $state.go(trans.$to().name, toStateParameters, {
                                reload: true
                            });
                        });
                    }
                    $state.go(trans.$from().name, {
                        reload: true
                    });
                } else {
                    if (ucdDatepickers.length > 0) {
                        ucdDatepickers.remove();
                    }
                }
                if ($rootScope.rpkServiceDisplayName && !trans.params('to').serviceCatalog) {
                    delete $rootScope.rpkServiceDisplayName;
                }

                if ($rootScope.serviceCatalog && !trans.params('to').serviceCatalog) {
                    delete $rootScope.serviceCatalog;
                }

                return defer.promise;
            }


            //子帐号时判断用户URL输入是否在权限内
            $rootScope.checkState = function (states) {
                var defer = $q.defer();
                serviceresource.menu.checkleftMenu(states.$current.name).then(function (data) {
                    if (!data) {
                        if (AUI.HDGWCall.getUserInfoValue('teamid')) {
                            $state.go('mysetting.memberDetail', {reload: true});
                        } else {
                            $state.go('home');
                        }
                        defer.reject();
                    } else {
                        defer.resolve(true);
                    }
                });
                return defer.promise;
            }


            // 监控angular.ui.route插件的 'stateChangeSuccess'事件
            function authenticateSuccess(states, trans) {
                // 在二级路由跳转之前，获取一些必须的信息
                /* 初始化开始 */
                states.url = states.current.url.replace(/(^.+)\/.+/, '$1');
                //设置左侧菜单不展示
                // 设置二级菜单默认跳转的子页面。
                switch (states.url) {
                    case '/new-earnings':
                        $state.go('MyAccount.newEarnings.settlement');
                        break;
                    case '/bills':
                        $state.go('MyAccount.bills.settlement');
                        break;
                    case '/nameChangeCorp':
                        $state.go('nameChangeCorp.userInfoCorp');
                        break;
                    case '/nameChangePer':
                        $state.go('nameChangePer.userInfoPer');
                        break;
                    case '/mysetting':
                        $state.go('mysetting.userInfo');
                        break;
                    case '/project':
                        $state.go('project.myapi');
                        break;
                    default:
                        break;
                }
                if (trans.$to().name.indexOf("myServiceList") >= 0) {
                    var length = $location.url().split('/').length;
                    $scope.$broadcast('transfer.myservicesList', length);
                }
                if (AUI.BaseJSUtil.contains(mainCons.modUserinfoConstant.nameChangeUrl, trans.$to().name)) {
                    $scope.$broadcast('transfer.nameChange', trans.$to().name);
                }
                getLeftMenu().forEach(function(menu) {
                    menu.isOpen = false;
                })
                // 菜单展开
                if (trans.$to().name.indexOf("mysetting") >= 0 ) {
                    getLeftMenu().forEach(function(menu){
                        if(menu.hashList.indexOf('mysetting')>-1){
                            menu.isOpen = true;
                        }
                    })
                }
                if (trans.$to().name.indexOf("MyAccount") >= 0 || trans.$to().name.indexOf("consumptionRecord") >= 0 || trans.$to().name.indexOf("balance") >= 0) {
                    getLeftMenu().forEach(function(menu){
                        if(menu.hashList.indexOf('MyAccount')>-1){
                            menu.isOpen = true;
                        }
                    })
                    $scope.$broadcast('transfer.myAccount', trans.$to().name);
                }
                if (!(trans.$to().name.indexOf("rollout") >= 0 && trans.$to().name.indexOf("submitSuccess") == -1)) {
                    Model.showMt = true;
                } else {
                    Model.showMt = false;
                }
                if (trans.$from().name == 'mysetting.modBussnessInfo' || trans.$to().name == 'mysetting.modBussnessInfo') {
                    $rootScope.$emit("stateChangedEvent", true);
                }
                if (trans.$to().name.indexOf("rollout") == -1) {
                    Model.showTop = true;
                } else {
                    Model.showTop = false;
                }
                //当用户信息变更时，需要更新右上角的菜单
                initUserSettingProfile(trans.from(), trans.to(), trans);
                angular.element("main").css("height", "auto");
                angular.element("body").css("margin-top", "0");
            }

            //当用户信息变更时，需要更新右上角的菜单
            function initUserSettingProfile(stateFrom, states, transition) {
                // 进入用户信息中心需要刷新MemberCenter的Model
                var tmp = transition.targetState();
                if (["mysetting.modUserInfoCorp", "mysetting.modUserInfoPer"].indexOf(states.name) > -1 && tmp && tmp._params && tmp._params.refresh) {
                    UserInfo.updateCache(function (userInfo) {
                        //保持变量内存地址不变，其他的Ajax可以异步修改相同的内存，以供页面展示
                        Model.userInfo.updateRealState = userInfo.updateRealState;
                        //首次可以不更新，理论上不会变化
                        Model.userInfo.verifyRealState = userInfo.verifyRealState;
                    });
                }
            }

            function gotoUserCenter() {
                AUI.BaseJSUtil.redirectUrlByBlank(sysUrlCfg.header.userCenter);
            }

            function showClick(funName) {
                if (funName == 'iframe-help') {
                    Model.iframhelp();
                } else {
                    $scope[funName]();
                }
            }

            function showHelp(flag) {
                //商户界面不弹新手指导了
                if ($state.$current.name == 'mysetting.modBussnessInfo') return;
                // 确定是否需要提示新手指引
                UserInfo.getUserRouteInfo().then(function (data) {
                    if (data && angular.isArray(data.roleList) && (AUI.BaseJSUtil.contains(data.roleList, roleTypeCfg.SM) || AUI.BaseJSUtil.contains(data.roleList, roleTypeCfg.HiLink) || AUI.BaseJSUtil.contains(data.roleList, roleTypeCfg.HiLink))) {
                        if (Model.userInfo && Model.userInfo.isEAMAccount) {//管理式帐号不展示团队帐号相关的广告以及欢迎广告弹窗
                            return;
                        }
                        if ((flag && Model.userInfo && Model.userInfo.isPlayGuide == 1) || AUI.HDGWCall.getUserInfoValue('teamid')) {
                            if ($state.$current.name == 'serviceCards') remindToUpdateUserInfo.appPromotionService();
                            return;
                        }
                        var userNow = Model.userInfo;
                        var handler = ngDialog.open({
                            template: 'pages/common/dialog.showhelp.html',
                            className: '',
                            closeByEscape: false,
                            closeByDocument: false,
                            overlay: false,
                            controller: ['$scope', function ($scope) {
                                $scope.notAlertAgain = userNow.isPlayGuide;
                                $scope.forumDiversionConf = sysParamCfg.forumDiversionConf;
                                $scope.developNoviceGuide = sysParamCfg.developNoviceGuide;
                                $scope.$watch('notAlertAgain', function () {
                                    if (arguments[0] != arguments[1]) {
                                        OpenUp.updateNotAuditInfo({
                                            req: {
                                                attributes2: JSON.stringify({
                                                    isPlayGuide: $scope.notAlertAgain ? "1" : "0"
                                                })
                                            }
                                        }).then(function () {
                                            Model.userInfo.isPlayGuide = ($scope.notAlertAgain ? "1" : "0");
                                        });
                                    }
                                });
                                $scope.changeAlertAgain = function () {
                                    $scope.notAlertAgain == 1 ? $scope.notAlertAgain = 0 : $scope.notAlertAgain = 1;
                                };
                                $scope.closeDialog = function () {
                                    handler.close();
                                    if ($state.$current.name == 'serviceCards') remindToUpdateUserInfo.appPromotionService();
                                };

                                $scope.showStep = function (num) {
                                    handler.close();
                                    var handlerChild = ngDialog.open({
                                        template: 'pages/common/dialog.showhelp.' + num + '.html',
                                        className: '',
                                        closeByEscape: false,
                                        closeByDocument: false,
                                        overlay: false,
                                        controller: ['$scope', function ($scope) {
                                            $scope.index = index;
                                            $scope.pageIndex = 1;
                                            if (num == 'zero') {
                                                $scope.pageContent = mainCons.help.setdesk;
                                            } else if (num == 'one') {
                                                $scope.pageContent = mainCons.help.createapp;
                                            } else if (num == 'four') {
                                                $scope.pageContent = mainCons.help.settle;
                                            } else if (num == 'five') {
                                                $scope.pageContent = mainCons.help.teamAccount;
                                            }
                                            setTimeout(function () {
                                                $('.userguide').data('Sliding') || new UCD.Sliding('.userguide', {
                                                    slideSelector: '.sample-grid',
                                                    isNeedPointer: true,
                                                    onChanged: function (index) {
                                                        $scope.$apply($scope.pageIndex = index + 1);
                                                    }
                                                });
                                            }, 700);

                                            $scope.closeDialog = function () {
                                                handlerChild.close();
                                                handler.close();
                                                if ($state.$current.name == 'serviceCards') remindToUpdateUserInfo.appPromotionService();
                                            };
                                            $scope.backToGuide = function () {
                                                handlerChild.close();
                                                showHelp();
                                            };
                                        }]
                                    });
                                };
                            }]
                        });
                    } else {
                        if ($state.$current.name == 'serviceCards') remindToUpdateUserInfo.appPromotionService();
                    }
                })

            }


            function refreshOrder() {
                var leftMenuList = getLeftMenu();
                $scope.hasorderListPermission = hasAuthority("Banlance", leftMenuList);
                if (!$scope.hasorderListPermission) {
                    return;
                }
                //查询待支付状态的订单个数
                var getOrderListRequest = {
                    fromRecCount: 1,
                    maxReqCount: 10,
                    sortType: 0,
                    sortField: "createTime",
                    status: [1]
                };
                OpenTrade.getOrderList({
                    req: getOrderListRequest
                }, true).then(function (data) {
                    var orderCount = data.totalCount;
                    if (orderCount > 0) {
                        if (orderCount > 99) {
                            orderCount = '99+';
                        }
                        Model.unPayedOrder = orderCount;
                    }
                });
            }

            function refreshUnreadQuestions() {
                var getUncheckTicketUrl = sysUrlCfg.esdk.codeserverDomain + "/partnercareservice/v1/ticket/getuncheckedticketcount";
                AUI.HDGWCall.callGWRest(getUncheckTicketUrl, {}, {type: "GET"})
                    .then(function (data) {
                        if (data.value) {
                            Model.unReadQuestions = data.value.count;
                        }
                    })
            }

            function refreshMsgNumber() {
                //查询站内信未读的消息个数
                var param = {
                    req: {}
                };
                param.req.channel = -1
                OpenOther.getUnreadNoteMsgNumber(param).then(function (resp) {
                    var newsCount = resp.unReadMsgNumber;
                    if (newsCount || newsCount === 0) {
                        if (newsCount > 99) {
                            newsCount = '99+';
                        }
                        Model.unReadMsgNum = newsCount;
                    }
                });
            }

            function refreshMemberService() {
                var leftMenuList = getLeftMenu();
                $scope.hasMemberServicesPermission = hasAuthority("MemberServices", leftMenuList);
                // 收益
                $scope.hasIncomePermission = hasAuthority("Income", leftMenuList);
                // 账单
                $scope.hasBillPermission = hasAuthority("Bill", leftMenuList);

            }


            function windowResize() {
                var _adjust = function () {
                    var screenWid = $(window).width();

                    $('.aside-nav').not('.aside-nav-sub').each(function () {

                        $scope.$apply(function () {
                            var $this = $(this);
                            if (screenWid < 1600) {
                                $scope.flag = true;
                                $this.addClass('shrinking');
                            } else {
                                $scope.flag = false;
                                _initAsideNav();
                            }
                        });
                    });
                };
                _adjust();
                $(window).resize(_adjust);
            }

            function _initAsideNav() {
                $('.ucd-fastmenu').each(function () {
                    new UCD.FastMenu(this, {
                        queueSize: 3,
                        delay: 300,
                        activeClassName: 'open'
                    });
                });
            }


            //判断是否具有itemName 权限
            function hasAuthority(itemCode, leftMenuList) {
                var ret = false;
                for (var i = 0; i < leftMenuList.length; i++) {
                    if (leftMenuList[i].resourceTree && leftMenuList[i].resourceTree.length > 0 && !ret) {
                        ret = hasAuthority(itemCode, leftMenuList[i].resourceTree);
                    } else {
                        if (leftMenuList[i].itemCode == itemCode) {
                            ret = true;
                        }
                    }
                }

                return ret;
            }

            // 获取服务卡片菜单
            function getServiceCardMenu() {
                return serviceresource.menu.getServiceCardMenu();
            }

            // 获取报表卡片菜单
            function getReportCardMenu() {

                return serviceresource.menu.getReportCardMenu();

            }

            // 获取账户菜单
            function getAccountCardMenu() {

                return serviceresource.menu.getAccountCardMenu();

            }

            // 获取设置菜单
            function getMySettingMenu() {

                return serviceresource.menu.getMySettingMenu();

            }

            //获取左侧菜单
            function getLeftMenu() {
                return serviceresource.menu.getLeftMenu();
            }

            //获取导航菜单
            function getNavigationMenu() {
                return serviceresource.menu.getNavigationMenu();
            }

            // 判断目录下是否存在定制卡片
            function hasCustomizedServiceCards(dirId) {
                return serviceresource.customizer.hasCustomizedServiceCards(dirId);
            }

            // 判断目录下是否存在定制卡片
            function hasCustomizedReportCards(dirId) {
                return serviceresource.customizer.hasCustomizedReportCards(dirId);
            }

            // 显示自定义卡片向导
            function initCustomizerGuide() {
                OpenOther.getUserSettingData({
                    req: {
                        lang: 'zh'
                    }
                }).then(function (data) {
                    if (data.value !== "Y") {
                        $scope.isCustomizerGuideShown = true;
                        //左侧菜单会浮动在蒙层上面
                        $scope.isCustomizerShown = true;
                        handTipMsg();
                    } else {
                        // 已弹出过向导
                        // 檢查是否有应用转移的请求
                        auiAppTransferService.appTransferService().then(function (data) {
                            handTipMsg();
                            //处理使用向导
                            if (data != 'showTips') {
                                showHelp(true);
                            }
                        });
                        isFirstTimeGuide = false;
                    }
                }, function (err) {
                });
            }

            //处理横幅提示
            function handTipMsg() {
                //应用转移处理完再解决横幅问题
                // 如果有返回值，就代表是切换到协议平台了。 返回的是需要重签但是非强制重签的协议列表
                if (templateInfoList && templateInfoList !== true && templateInfoList.length > 0) {
                    $scope.agreeList = templateInfoList; //非强签协议list
                }
                $scope.setTipMsg($state.$current.name).then(function (result) {
                    $scope.msgList = $scope.filterClosedMsg(result);
                    displayAgreeListNew($scope.msgList);
                });
            }

            // 显示自定义卡片界面
            function showCustomizer() {
                serviceresource.cache.getData().then(function (res) {
                    if (!res.data || !res.data.serviceCards.length) {
                        showError();
                        return;
                    }

                    $scope.isCustomizerShown = true;
                    $scope.isCustomizerGuideShown = false;
                    $scope.selectState = 1;

                    $timeout(function () {
                        var elementsScroll = [];
                        var dialogContent = angular.element(".dialog-content");
                        angular.element(".dialog-content > div[id]").each(function (index, item) {
                            elementsScroll.push(item.offsetTop);
                        });
                        var oldTop = 0;
                        dialogContent.scroll(function (e) {
                            if (isSelectTab) {
                                isSelectTab = false;
                                return;
                            }
                            isSelectTab = false;
                            var clientHeight = this.clientHeight;
                            var newTop = this.scrollTop;
                            if (newTop > oldTop) { //向下滚动
                                for (var j = elementsScroll.length - 1; j >= 0; j--) {
                                    var itemj = elementsScroll[j];
                                    if (newTop + clientHeight >= itemj) {
                                        $scope.selectState = j + 1;
                                        break;
                                    }
                                }
                            } else { //向上滚动
                                for (var i = 0; i < elementsScroll.length; i++) {
                                    var item = elementsScroll[i];
                                    if (newTop <= item) {
                                        $scope.selectState = i + 1;
                                        break;
                                    }
                                }
                            }
                            oldTop = newTop;
                            $scope.$apply();
                        });
                    }, 1);
                }, function (err) {
                    showError();
                });

                // 无卡片时
                function showError() {
                    auiDialog.warn('您的服务权限暂未开通，请您联系客服人员咨询及解决。', function () {
                        $scope.isCustomizerShown = false;
                        $scope.isCustomizerGuideShown = false;
                        if (isFirstTimeGuide) {
                            noShowCustomizerGuide();
                        }
                    });
                }
            }

            // 获取全部服务卡片
            function getAllServiceCards() {
                return serviceresource.cards.getAllServiceCards();
            }

            // 定制卡片
            function customizeCard(card) {
                serviceresource.customizer.customize(card);
            }

            // 不再显示自定义卡片向导
            function noShowCustomizerGuide() {
                OpenOther.saveUserSettingData({
                    req: {
                        desktopFlag: "Y"
                    }
                }).then(function (data) {
                    isFirstTimeGuide = false;
                    $scope.isCustomizerGuideShown = false;
                });
            }

            $rootScope.toSettingUserInfo = function () {
                if (!AUI.HDGWCall.getUserInfoValue('teamid')) {
                    if (Model.userInfo.userType == 1) {
                        $state.go('mysetting.modUserInfoPer', {}, {reload: true});
                    } else if (Model.userInfo.userType == 2) {
                        modUserInfoService.getExtAttr('reAutoVerify').then(function (data) {
                            //打款认证的，如果是初次的是3 1  如果是应用市场AGC进来的 reAutoVerify == 1 然后就是可以到打款
                            if ((Model.userInfo.verifyType == 3 && Model.userInfo.verifyRealState == 1) || (data && data == 1 && Model.userInfo.updateRealState == 1)) {
                                $state.go('mysetting.validCorpattion', {}, {reload: true});
                            } else {
                                $state.go('mysetting.modUserInfoCorp', {}, {reload: true});
                            }
                        })
                    }
                } else {
                    $state.go('mysetting.memberDetail', {}, {reload: true});
                }
            }

            Model.showMyAccountMenu = function (menuType) {
                $rootScope.showAccountMenu(menuType);
            };
            $rootScope.showPayServ = function (stateUrl) {
                if (!!stateUrl) {
                    $state.go(stateUrl);
                } else {
                    $state.go('mysetting.payService.modInvoice', {}, {reload: true});
                }
            };
            Model.showTeamMemberMenu = function () {
                $state.go('mysetting.teamAccountInfoList', {}, {reload: true});
            };

            $rootScope.showBussness = function () {
                $state.go('mysetting.modBussnessInfo', {}, {reload: true});
            };
            Model.iframhelp = function () {
                $state.go('iframe-help', {}, {reload: true});
            };
            $rootScope.showAccountMenu = function (menuType) {
                if (menuType == mainCons.modUserinfoConstant.myAccountChildMenu.balance) {
                    $state.go('MyAccount.mainbalance', {signParty: 0}, {reload: true});
                }
            }

            //切团队帐号
            function changeTeamAccount(userRouteInfo) {
                if (userRouteInfo.userID == Model.userInfo.id) return;
                var nowUserRouteInfo = angular.copy(userRouteInfo)
                serviceresource.clearCache();
                auiChangeTeamAccountService.changeTeamAccount(userRouteInfo).then(function (res) {
                    if (res.resultCode == 0) {
                        if (Model.userRouteInfo && Model.userRouteInfo.userRouteInfoList && Model.userRouteInfo.userRouteInfoList.length > 0) {
                            Model.userRouteInfo.userRouteInfoList.forEach(function (item) {
                                if (item.userID == nowUserRouteInfo.userID) {
                                    Model.userRouteInfo.userRouteInfoList.splice(Model.userRouteInfo.userRouteInfoList.indexOf(userRouteInfo), 1);
                                }
                            })
                        }
                    }
                });
            }


            //注销
            function logOut() {
                UserInfo.logOut();
            }
        }
    ]);
});

